import type { CSSProperties } from 'react';

const box: CSSProperties = {
  padding: 16,
  borderRadius: 8,
  background: '#fff',
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
};

const errorBox: CSSProperties = {
  ...box,
  background: '#fef2f2',
  color: '#b91c1c',
};

const muted: CSSProperties = {
  color: '#6b7280',
  padding: 16,
};

const retryButton: CSSProperties = {
  marginTop: 12,
  padding: '8px 16px',
  background: '#2563eb',
  color: '#fff',
  border: 'none',
  borderRadius: 6,
  fontWeight: 500,
  cursor: 'pointer',
};

export interface AnalyticsQueryStateProps {
  loading: boolean;
  error: string | null;
  onRetry: () => void;
  isEmpty: boolean;
  emptyMessage?: string;
  children: React.ReactNode;
}

/**
 * Loading, error + retry, and empty states for analytics sections (PRD §6.2 / TRD §3).
 */
export function AnalyticsQueryState({
  loading,
  error,
  onRetry,
  isEmpty,
  emptyMessage = 'No data for this period.',
  children,
}: AnalyticsQueryStateProps) {
  if (loading) {
    return <p style={muted}>Loading…</p>;
  }
  if (error) {
    return (
      <div style={errorBox} role="alert" data-testid="analytics-error">
        <p style={{ margin: 0 }}>{error}</p>
        <button type="button" style={retryButton} onClick={onRetry} data-testid="analytics-retry">
          Try again
        </button>
      </div>
    );
  }
  if (isEmpty) {
    return (
      <p style={muted} data-testid="analytics-empty">
        {emptyMessage}
      </p>
    );
  }
  return <>{children}</>;
}
